(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(`._header_m076r_1{z-index:3;background-color:#fff}._header_container_m076r_6{margin-bottom:2px}._neu-image_wrapper_m076r_10{max-width:100%;height:auto}._neu_image_wrapper_m076r_15{display:flex;align-items:center}@media (max-width: 576px){._neu_image_wrapper_m076r_15{justify-content:center;width:100%}}._neu_image_wrapper_m076r_15 .neu-image{margin:0 auto}
._top_navigation_container_br4ci_1{white-space:nowrap}._neu-dropdown_br4ci_5:hover{padding:var(--neu-spacer-2, 4px);border-radius:50%;color:var(--neu-blue-60)}._dropdown_items_br4ci_11{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._dropdown_items_active_br4ci_16{background-color:var(--link-pressed-background, #6a91af)}@media (max-width: 993px){._dropdown_container_br4ci_21{display:none}}@media (min-width: 993px){._mobile_menu_br4ci_27{display:none}}
._mhoTabsWrapper_1vsck_1{display:grid;grid-template-columns:1fr;gap:var(--neu-spacer-6, 24px);align-items:start;margin-top:var(--neu-spacer-3, .5rem)}@media (min-width: 768px){._mhoTabsWrapper_1vsck_1{gap:var(--neu-spacer-7, 32px);grid-template-columns:224px 1fr}}@media (min-width: 992px){._mhoTabsWrapper_1vsck_1{grid-template-columns:312px 1fr}}._mhoTabsWrapper_1vsck_1 ._noBackgroundTab_1vsck_19{background:none;box-shadow:none!important}._mhoTabsWrapper_1vsck_1 ._minH320_1vsck_23{min-height:320px}._mhoTabsWrapper_1vsck_1.neu-list{box-shadow:var(--neu-elevation-1) var(--neu-elevation-color)}
._certificationImageContainer_1gn0m_1{display:flex;justify-content:end;align-items:center;width:100%}@media (max-width: 660px){._certificationImageContainer_1gn0m_1{justify-content:center;width:100%;height:72px}}._certificationImageContainer_1gn0m_1>button>figure{margin:0}._imageContainer_1gn0m_19>figure{margin:0}._certificationButton_1gn0m_23{padding:var(--neu-spacer-0);background-color:transparent;min-width:auto;min-height:auto;border:none;text-align:center;cursor:pointer}._certificationButton_1gn0m_23:active,._certificationButton_1gn0m_23:focus,._certificationButton_1gn0m_23:hover{transform:scale(1.2);transition:transform .3s ease-in-out;background-color:transparent}._certificationButton_1gn0m_23:focus-visible{outline:revert;background-color:transparent}._modal_wrapper_3fxo4_1{max-height:600px}._modal_header_3fxo4_5{text-align:center}._modal_description_3fxo4_9{padding-top:20px;text-align:left;line-height:26px}._modal_description_3fxo4_9>p{line-height:26px}._modal_description_3fxo4_9>ul>li::marker{font-size:1.5em;font-weight:700}._modal_description_3fxo4_9>ul{padding-left:22px}._modal_image_3fxo4_28{width:200px}._footerSection_96jav_1{padding:70px 0 30px;background-color:#fff}@media (max-width: 768px){._footerSection_96jav_1{padding:30px var(--neu-spacing-0, 0px)}}._footerContainer_96jav_11{padding:var(--neu-spacing-0, 0) var(--neu-spacing-4, 12px);display:grid;grid-template-columns:1fr 1fr;grid-template-areas:"contact privacy" "links links"}@media (min-width: 1400px){._footerContainer_96jav_11{max-width:1320px}}@media (max-width: 660px){._footerContainer_96jav_11{align-items:center;grid-template-columns:1fr;grid-template-areas:"contact" "links" "privacy";place-items:center}}._contactArea_96jav_31{grid-area:contact}._logoImageContainer_96jav_35{display:flex;justify-content:start;padding-bottom:10px}@media (max-width: 660px){._logoImageContainer_96jav_35{justify-content:center;padding-bottom:var(--neu-spacing-6, 20px)}}._logoImageContainer_96jav_35>figure{margin:var(--neu-spacing-0, 0px)}._contactInfo_96jav_51{text-wrap:balance;text-align:center}@media (min-width: 768px){._contactInfo_96jav_51{text-align:start}}._linkArea_96jav_61{grid-area:links;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:center;padding-block:var(--neu-spacing-6, 20px);gap:var(--neu-spacing-6, 20px)}@media (min-width: 1024px){._linkArea_96jav_61{justify-content:start}}@media (max-width: 660px){._linkArea_96jav_61{flex-direction:column;align-items:center;gap:10px}}._privacyArea_96jav_84{grid-area:privacy;display:grid;grid-template-areas:"certification-image" "privacy-info"}@media (min-width: 1024px){._privacyArea_96jav_84{column-gap:20px;grid-template-columns:1fr max-content;grid-template-areas:"privacy-info certification-image"}}@media (max-width: 660px){._privacyArea_96jav_84{column-gap:20px;align-items:center}}._privacyInfoContainer_96jav_103{grid-area:privacy-info;display:flex;flex-direction:column;align-items:end;padding-top:var(--neu-spacing-1, 2px)}@media (max-width: 660px){._privacyInfoContainer_96jav_103{padding:var(--neu-spacing-6, 20px);align-items:center;text-align:center}}@media (min-width: 1024px){._privacyInfoContainer_96jav_103{justify-content:center}}._privacyInfo_96jav_103{text-wrap:balance;text-align:center}@media (min-width: 768px){._privacyInfo_96jav_103{text-align:end}}
._mho_alert_wrapper_1lqun_1 .neu-snackbar{--snackbar-radius: 0}
._table_usmlv_1 th{border-top:none;padding:var(--neu-spacing-4, .75rem) 0 var(--neu-spacing-3, .5rem)}._table_usmlv_1 th:not(:last-of-type){width:50%}@media (min-width: 360px){._table_usmlv_1 th:not(:last-of-type){width:60%}}@media (min-width: 576px){._table_usmlv_1 th:not(:last-of-type){width:70%}}@media (min-width: 992px){._table_usmlv_1 th:not(:last-of-type){width:37.5%}}@media (min-width: 1200px){._table_usmlv_1 th:not(:last-of-type){width:40%}}@media (max-width: 480px){._table_usmlv_1 th:not(:last-of-type) h3{white-space:normal!important}}._table_usmlv_1 td{padding:var(--neu-spacing-4, .75rem) 0;max-width:0}._table_usmlv_1 td p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._table_usmlv_1 tr:last-of-type>td{border-bottom:none}._table_usmlv_1 tfoot{border-top:1px solid var(--table-border)}@media (max-width: 992px){._table_usmlv_1 th{padding:var(--neu-spacing-1, .125rem) 0}._table_usmlv_1 td{padding:var(--neu-spacing-3, .5rem) 0}}._table_usmlv_1 tbody tr:hover :is(th,td){background:var(--table-background)!important}._description_usmlv_64 p,._item_usmlv_65 p{margin:0}._description_usmlv_64>td,._item_usmlv_65>td{border-top:none}._item_usmlv_65>td:first-of-type{max-width:75px}@media (min-width: 576px){._item_usmlv_65>td:first-of-type{max-width:85px}}@media (min-width: 992px){._item_usmlv_65>td:first-of-type{max-width:110px}}._item_usmlv_65>td:last-of-type{width:auto;max-width:none}._description_usmlv_64>td{padding-top:0}._headerRowWithDescription_usmlv_99 th{padding:0;border-bottom:none}._headerRowWithDescription_usmlv_99+tr>td{padding:0;padding-bottom:var(--neu-spacing-3, .5rem);border-top:none}
._formInput_tgf87_1 button{text-align:left}._divider_23elx_1{width:100%;height:1px}
._card_items_1xzq2_1{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._card_items_1xzq2_1:hover,._card_items_1xzq2_1:focus{background-color:var(--neu-gray-10, #e2e2e2)}._card_items_1xzq2_1:active{background-color:var(--neu-blue-10, #d3e5f2)}@media (min-width: 768px){._card_items_1xzq2_1._header_link_1xzq2_12{display:none}}._link_icon_container_1xzq2_17{width:var(--neu-spacer-6, 1.5rem);text-align:center}._link_icon_container_1xzq2_17>figure{margin:0}._userEmail_std5a_1{text-overflow:ellipsis;max-width:284px}._profileCardContainer_std5a_6{padding-left:1.5rem}._profileCardContainer_std5a_6 .neu-dropdown--menu{max-width:284px!important;transform:translate3d(2px,23px,0)!important}@media (max-width: 660px){._profileCardContainer_std5a_6 .neu-dropdown--menu{inset:0px 0px auto auto;transform:translate3d(4px,23px,0)}}._profileCardContainer_std5a_6 .neu-dropdown--menu ul{max-height:none!important}._profileCardContainer_std5a_6 .neu-dropdown--menu li,._profileCardContainer_std5a_6 .neu-dropdown--menu a{width:284px!important}._profileCardContainer_std5a_6 .neu-dropdown--menu a:hover{color:var(--neu-gray-100)}._firstName_std5a_31{font-size:20px!important;text-overflow:ellipsis;max-width:284px}
._description_35t4d_1 p{margin:0}@media (min-width: 768px){._addLinkForm-input1_35t4d_6{width:33%}}@media (min-width: 768px){._addLinkForm-input2_35t4d_12{width:66%}}._disclaimerText_35t4d_17{line-height:1.125rem}
._formInput_ffgvo_1{display:flex;align-items:center;width:var(--custom-width, 100%)}._card_1b673_1{width:100%;aspect-ratio:3/1.8;border:3px dashed rgb(var(--neu-gray-10-light, 226, 226, 226));background-color:rgb(var(--neu-plain-0-light, 255, 255, 255));border-radius:var(--neu-border-radius-default, 8px);overflow:hidden}._card_1b673_1:has(input:focus){border-color:rgb(var(--neu-gray-20-light, 226, 226, 226))}@media (min-width: 769px){._card_1b673_1{max-height:220px}}._icon_1b673_18{font-size:2.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin-bottom:10px}._cardTitletext_1b673_24{font-size:1.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin:0;padding:5px 0}@media (max-width: 576px){._cardTitletext_1b673_24{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._description_1b673_39{font-size:var(--neu-font-size, 1rem);color:rgb(var(--neu-gray-10-dark, 31, 31, 31));margin:0}@media (max-width: 576px){._description_1b673_39{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._alertError_1b673_53{padding:var(--neu-spacer-4, .75rem);text-align:center;margin-top:var(--neu-spacer-5, 1rem);position:relative}._uploadedImageWrapper_1b673_60{width:100%;height:100%}._uploadedImage_1b673_60{width:100%;height:100%;position:relative;transform:translate(-50%,-50%);top:50%;left:50%}._uploadedImage_1b673_60 figure{width:100%;height:100%;margin:0}._uploadedImage_1b673_60 figure div{height:100%;width:100%}._uploadedImage_1b673_60 figure img{width:100%;height:100%;object-fit:contain}._reuploadMessage_1b673_88{position:absolute;bottom:0;left:0;color:#fff!important;background:#00000080;width:100%;text-align:center;padding:5px 0;display:none!important;z-index:10}._uploadedContainer_1b673_101{position:relative;width:100%;height:100%}._uploadedContainer_1b673_101:focus,._uploadedContainer_1b673_101:hover>div._reupload_message_1b673_106{display:block!important}._fileInput_1b673_110{height:1px;width:1px;opacity:0;position:absolute}
._formItem_r52t0_1{flex:1}
._linkField_kas8y_1{min-width:fit-content;padding-top:var(--neu-spacing-2, .25rem)}._text_field_1gmpc_1 p{margin:0}@media (max-width: 768px){._image_field_1gmpc_7{height:6.25rem;width:6.25rem}}._divider_h91qf_1{height:1px;transform:translateY(-21px)}
._modalContentContainer_10hs1_1{max-height:90vh;overflow:auto}@media (max-width: 475px){._modalContentContainer_10hs1_1{max-height:85vh}}
._description_1nfzp_1 p{margin:0}._searchItem_1nfzp_5{background-color:var(--neu-plain-0, #fff)}._noItemErrorMessage_1nfzp_9 ul li::marker{color:var(--neu-plain-100, #000)}
._horizontalTabsWrapper_lulv0_1{display:flex;width:100%}._horizontalTabsWrapper_lulv0_1 .unit-tab{flex:1 1 0;min-width:0;align-items:center;justify-content:center}._horizontalTabsWrapperSc_lulv0_12{padding-left:0;padding-right:0}._horizontalTabsCard_lulv0_17 .unit-content{padding:0}
._imageContainer_1xsj3_1{margin:16px 0;position:relative;min-height:104px;min-width:104px;height:fit-content;width:fit-content}._editButton_1xsj3_10{position:absolute;bottom:0;right:0;background-color:var(--neu-gray-10, "#e2e2e2")!important}._fileInput_1xsj3_17{width:1px;height:1px;display:none}._formItemPreferredFacilityState_1eisr_1{width:100%!important;min-width:50%!important;flex:1}@media screen and (min-width: 960px){._formItemPreferredFacilityState_1eisr_1{flex:.2;max-width:140px!important;min-width:140px!important}}._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{width:100%!important;padding-right:24px!important}@media screen and (max-width: 380px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:265px!important}}@media screen and (min-width: 381px) and (max-width: 575px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:305px!important}}@media screen and (min-width: 576px) and (max-width: 820px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:196px!important}}@media screen and (min-width: 821px) and (max-width: 1024px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:320px!important}}`)),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsxs as b, jsx as l, Fragment as D } from "react/jsx-runtime";
import { useState as H, useEffect as me, useMemo as Re } from "react";
import { useI18n as x } from "next-localization";
import { c as er } from "../../chunks/clsx.OuTLNxxd.js";
import { useFormContext as en, useForm as rn } from "react-hook-form";
import { a as ie } from "../../chunks/api.DHdhNbok.js";
import { u as nn } from "../../chunks/use-accounts-relationships.L7d75NNZ.js";
import { u as tn } from "../../chunks/use-is-auth-token-generated.BkMrw8To.js";
import { NeuModal as fe, NeuButton as ue, NeuTooltip as an, NeuAvatar as on, NeuPassword as sn, NeuCheckbox as ln, NeuCard as fn, NeuFeedback as dn, NeuSnackbar as cn } from "@hcahealthcaredpx/neutron-react";
import { o as mn, s as c, l as V, u as un, a as pn } from "../../chunks/types.BJMlOVBS.js";
import { useQuery as rr, useMutation as hn, useQueryClient as Pn } from "@tanstack/react-query";
import { S as nr, q as pe } from "../../chunks/stale.constant.De1PuSBj.js";
import { a as gn, u as yn } from "../../chunks/use-update-account.Cr_jUcK8.js";
import { C as tr, F as he, E as ar, b as L, R as A, c as bn } from "../../chunks/form-mask-input.92EW49hv.js";
import { F as S, a as v, b as F } from "../../chunks/form-wrapper.CxSd-0ur.js";
import { g as ir, a as or, b as ee, c as sr, d as Mn, e as lr, f as fr, h as In, j as dr, o as Sn, k as Z, l as cr, n as re, T as An, P as _n } from "../../chunks/page-content.B0ugSU6N.js";
import { withDatasourceCheck as wn } from "@sitecore-jss/sitecore-jss-nextjs";
import { u as Tn } from "../../chunks/use-update-relationship.BhM7x_In.js";
import { u as vn } from "../../chunks/use-connected-relationship-info.DvMNYpDA.js";
import { saveTimestampToLocalStorage as Cn } from "../../utils/storage/index.js";
import { a as R, S as z, i as K, b as En, r as mr } from "../../chunks/isArray.CdbPONHA.js";
import { i as ur, t as Ln, a as On } from "../../chunks/toString.BD2eC2l5.js";
import { b as xn } from "../../chunks/date-formatters.D53NL80z.js";
import { u as Gn } from "../../chunks/use-accounts-relation-types.BZfXDW3J.js";
import { F as Nn } from "../../chunks/form-date-picker.LFmaEfS6.js";
import { u as Fn } from "../../chunks/useWindowResize.D9fgrnqD.js";
import { c as Rn } from "../../chunks/use-account.DkVfV1FC.js";
function $n(e) {
  return e;
}
function Un(e, r, n) {
  switch (n.length) {
    case 0:
      return e.call(r);
    case 1:
      return e.call(r, n[0]);
    case 2:
      return e.call(r, n[0], n[1]);
    case 3:
      return e.call(r, n[0], n[1], n[2]);
  }
  return e.apply(r, n);
}
var jn = 800, qn = 16, Dn = Date.now;
function Hn(e) {
  var r = 0, n = 0;
  return function() {
    var t = Dn(), a = qn - (t - n);
    if (n = t, a > 0) {
      if (++r >= jn)
        return arguments[0];
    } else
      r = 0;
    return e.apply(void 0, arguments);
  };
}
function zn(e) {
  return function() {
    return e;
  };
}
var ne = function() {
  try {
    var e = ir(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Bn = ne ? function(e, r) {
  return ne(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: zn(r),
    writable: !0
  });
} : $n, Vn = Hn(Bn);
function Zn(e, r) {
  for (var n = -1, t = e == null ? 0 : e.length; ++n < t && r(e[n], n, e) !== !1; )
    ;
  return e;
}
var Kn = 9007199254740991, Yn = /^(?:0|[1-9]\d*)$/;
function Xn(e, r) {
  var n = typeof e;
  return r = r ?? Kn, !!r && (n == "number" || n != "symbol" && Yn.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
function pr(e, r, n) {
  r == "__proto__" && ne ? ne(e, r, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[r] = n;
}
function Pe(e, r) {
  return e === r || e !== e && r !== r;
}
var Qn = Object.prototype, Jn = Qn.hasOwnProperty;
function hr(e, r, n) {
  var t = e[r];
  (!(Jn.call(e, r) && Pe(t, n)) || n === void 0 && !(r in e)) && pr(e, r, n);
}
function Wn(e, r, n, t) {
  var a = !n;
  n || (n = {});
  for (var i = -1, o = r.length; ++i < o; ) {
    var s = r[i], d = void 0;
    d === void 0 && (d = e[s]), a ? pr(n, s, d) : hr(n, s, d);
  }
  return n;
}
var $e = Math.max;
function kn(e, r, n) {
  return r = $e(r === void 0 ? e.length - 1 : r, 0), function() {
    for (var t = arguments, a = -1, i = $e(t.length - r, 0), o = Array(i); ++a < i; )
      o[a] = t[r + a];
    a = -1;
    for (var s = Array(r + 1); ++a < r; )
      s[a] = t[a];
    return s[r] = n(o), Un(e, this, s);
  };
}
function et(e, r) {
  for (var n = -1, t = Array(e); ++n < e; )
    t[n] = r(n);
  return t;
}
var rt = Object.prototype, nt = rt.hasOwnProperty;
function Pr(e, r) {
  var n = R(e), t = !n && or(e), a = !n && !t && ee(e), i = !n && !t && !a && sr(e), o = n || t || a || i, s = o ? et(e.length, String) : [], d = s.length;
  for (var f in e)
    (r || nt.call(e, f)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    Xn(f, d))) && s.push(f);
  return s;
}
function tt(e) {
  return lr(e) ? Pr(e) : Mn(e);
}
function at(e) {
  var r = [];
  if (e != null)
    for (var n in Object(e))
      r.push(n);
  return r;
}
var it = Object.prototype, ot = it.hasOwnProperty;
function st(e) {
  if (!fr(e))
    return at(e);
  var r = In(e), n = [];
  for (var t in e)
    t == "constructor" && (r || !ot.call(e, t)) || n.push(t);
  return n;
}
function lt(e) {
  return lr(e) ? Pr(e, !0) : st(e);
}
var ft = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, dt = /^\w*$/;
function ct(e, r) {
  if (R(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || ur(e) ? !0 : dt.test(e) || !ft.test(e) || r != null && e in Object(r);
}
var Y = ir(Object, "create");
function mt() {
  this.__data__ = Y ? Y(null) : {}, this.size = 0;
}
function ut(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var pt = "__lodash_hash_undefined__", ht = Object.prototype, Pt = ht.hasOwnProperty;
function gt(e) {
  var r = this.__data__;
  if (Y) {
    var n = r[e];
    return n === pt ? void 0 : n;
  }
  return Pt.call(r, e) ? r[e] : void 0;
}
var yt = Object.prototype, bt = yt.hasOwnProperty;
function Mt(e) {
  var r = this.__data__;
  return Y ? r[e] !== void 0 : bt.call(r, e);
}
var It = "__lodash_hash_undefined__";
function St(e, r) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Y && r === void 0 ? It : r, this;
}
function q(e) {
  var r = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++r < n; ) {
    var t = e[r];
    this.set(t[0], t[1]);
  }
}
q.prototype.clear = mt;
q.prototype.delete = ut;
q.prototype.get = gt;
q.prototype.has = Mt;
q.prototype.set = St;
function At() {
  this.__data__ = [], this.size = 0;
}
function oe(e, r) {
  for (var n = e.length; n--; )
    if (Pe(e[n][0], r))
      return n;
  return -1;
}
var _t = Array.prototype, wt = _t.splice;
function Tt(e) {
  var r = this.__data__, n = oe(r, e);
  if (n < 0)
    return !1;
  var t = r.length - 1;
  return n == t ? r.pop() : wt.call(r, n, 1), --this.size, !0;
}
function vt(e) {
  var r = this.__data__, n = oe(r, e);
  return n < 0 ? void 0 : r[n][1];
}
function Ct(e) {
  return oe(this.__data__, e) > -1;
}
function Et(e, r) {
  var n = this.__data__, t = oe(n, e);
  return t < 0 ? (++this.size, n.push([e, r])) : n[t][1] = r, this;
}
function G(e) {
  var r = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++r < n; ) {
    var t = e[r];
    this.set(t[0], t[1]);
  }
}
G.prototype.clear = At;
G.prototype.delete = Tt;
G.prototype.get = vt;
G.prototype.has = Ct;
G.prototype.set = Et;
function Lt() {
  this.size = 0, this.__data__ = {
    hash: new q(),
    map: new (dr || G)(),
    string: new q()
  };
}
function Ot(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
function se(e, r) {
  var n = e.__data__;
  return Ot(r) ? n[typeof r == "string" ? "string" : "hash"] : n.map;
}
function xt(e) {
  var r = se(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
function Gt(e) {
  return se(this, e).get(e);
}
function Nt(e) {
  return se(this, e).has(e);
}
function Ft(e, r) {
  var n = se(this, e), t = n.size;
  return n.set(e, r), this.size += n.size == t ? 0 : 1, this;
}
function N(e) {
  var r = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++r < n; ) {
    var t = e[r];
    this.set(t[0], t[1]);
  }
}
N.prototype.clear = Lt;
N.prototype.delete = xt;
N.prototype.get = Gt;
N.prototype.has = Nt;
N.prototype.set = Ft;
var Rt = "Expected a function";
function ge(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(Rt);
  var n = function() {
    var t = arguments, a = r ? r.apply(this, t) : t[0], i = n.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, t);
    return n.cache = i.set(a, o) || i, o;
  };
  return n.cache = new (ge.Cache || N)(), n;
}
ge.Cache = N;
var $t = 500;
function Ut(e) {
  var r = ge(e, function(t) {
    return n.size === $t && n.clear(), t;
  }), n = r.cache;
  return r;
}
var jt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, qt = /\\(\\)?/g, Dt = Ut(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(jt, function(n, t, a, i) {
    r.push(a ? i.replace(qt, "$1") : t || n);
  }), r;
});
function ye(e, r) {
  return R(e) ? e : ct(e, r) ? [e] : Dt(Ln(e));
}
function gr(e) {
  if (typeof e == "string" || ur(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -1 / 0 ? "-0" : r;
}
function Ht(e, r) {
  r = ye(r, e);
  for (var n = 0, t = r.length; e != null && n < t; )
    e = e[gr(r[n++])];
  return n && n == t ? e : void 0;
}
function be(e, r) {
  for (var n = -1, t = r.length, a = e.length; ++n < t; )
    e[a + n] = r[n];
  return e;
}
var Ue = z ? z.isConcatSpreadable : void 0;
function zt(e) {
  return R(e) || or(e) || !!(Ue && e && e[Ue]);
}
function Bt(e, r, n, t, a) {
  var i = -1, o = e.length;
  for (n || (n = zt), a || (a = []); ++i < o; ) {
    var s = e[i];
    n(s) ? be(a, s) : a[a.length] = s;
  }
  return a;
}
function Vt(e) {
  var r = e == null ? 0 : e.length;
  return r ? Bt(e) : [];
}
function Zt(e) {
  return Vn(kn(e, void 0, Vt), e + "");
}
var yr = Sn(Object.getPrototypeOf, Object), Kt = "[object Object]", Yt = Function.prototype, Xt = Object.prototype, br = Yt.toString, Qt = Xt.hasOwnProperty, Jt = br.call(Object);
function Wt(e) {
  if (!K(e) || En(e) != Kt)
    return !1;
  var r = yr(e);
  if (r === null)
    return !0;
  var n = Qt.call(r, "constructor") && r.constructor;
  return typeof n == "function" && n instanceof n && br.call(n) == Jt;
}
function kt(e, r, n) {
  var t = -1, a = e.length;
  r < 0 && (r = -r > a ? 0 : a + r), n = n > a ? a : n, n < 0 && (n += a), a = r > n ? 0 : n - r >>> 0, r >>>= 0;
  for (var i = Array(a); ++t < a; )
    i[t] = e[t + r];
  return i;
}
function ea() {
  this.__data__ = new G(), this.size = 0;
}
function ra(e) {
  var r = this.__data__, n = r.delete(e);
  return this.size = r.size, n;
}
function na(e) {
  return this.__data__.get(e);
}
function ta(e) {
  return this.__data__.has(e);
}
var aa = 200;
function ia(e, r) {
  var n = this.__data__;
  if (n instanceof G) {
    var t = n.__data__;
    if (!dr || t.length < aa - 1)
      return t.push([e, r]), this.size = ++n.size, this;
    n = this.__data__ = new N(t);
  }
  return n.set(e, r), this.size = n.size, this;
}
function O(e) {
  var r = this.__data__ = new G(e);
  this.size = r.size;
}
O.prototype.clear = ea;
O.prototype.delete = ra;
O.prototype.get = na;
O.prototype.has = ta;
O.prototype.set = ia;
var Mr = typeof exports == "object" && exports && !exports.nodeType && exports, je = Mr && typeof module == "object" && module && !module.nodeType && module, oa = je && je.exports === Mr, qe = oa ? mr.Buffer : void 0;
qe && qe.allocUnsafe;
function sa(e, r) {
  return e.slice();
}
function la(e, r) {
  for (var n = -1, t = e == null ? 0 : e.length, a = 0, i = []; ++n < t; ) {
    var o = e[n];
    r(o, n, e) && (i[a++] = o);
  }
  return i;
}
function Ir() {
  return [];
}
var fa = Object.prototype, da = fa.propertyIsEnumerable, De = Object.getOwnPropertySymbols, Sr = De ? function(e) {
  return e == null ? [] : (e = Object(e), la(De(e), function(r) {
    return da.call(e, r);
  }));
} : Ir, ca = Object.getOwnPropertySymbols, ma = ca ? function(e) {
  for (var r = []; e; )
    be(r, Sr(e)), e = yr(e);
  return r;
} : Ir;
function Ar(e, r, n) {
  var t = r(e);
  return R(e) ? t : be(t, n(e));
}
function He(e) {
  return Ar(e, tt, Sr);
}
function _r(e) {
  return Ar(e, lt, ma);
}
var ua = Object.prototype, pa = ua.hasOwnProperty;
function ha(e) {
  var r = e.length, n = new e.constructor(r);
  return r && typeof e[0] == "string" && pa.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var te = mr.Uint8Array;
function Me(e) {
  var r = new e.constructor(e.byteLength);
  return new te(r).set(new te(e)), r;
}
function Pa(e, r) {
  var n = Me(e.buffer);
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var ga = /\w*$/;
function ya(e) {
  var r = new e.constructor(e.source, ga.exec(e));
  return r.lastIndex = e.lastIndex, r;
}
var ze = z ? z.prototype : void 0, Be = ze ? ze.valueOf : void 0;
function ba(e) {
  return Be ? Object(Be.call(e)) : {};
}
function Ma(e, r) {
  var n = Me(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
var Ia = "[object Boolean]", Sa = "[object Date]", Aa = "[object Map]", _a = "[object Number]", wa = "[object RegExp]", Ta = "[object Set]", va = "[object String]", Ca = "[object Symbol]", Ea = "[object ArrayBuffer]", La = "[object DataView]", Oa = "[object Float32Array]", xa = "[object Float64Array]", Ga = "[object Int8Array]", Na = "[object Int16Array]", Fa = "[object Int32Array]", Ra = "[object Uint8Array]", $a = "[object Uint8ClampedArray]", Ua = "[object Uint16Array]", ja = "[object Uint32Array]";
function qa(e, r, n) {
  var t = e.constructor;
  switch (r) {
    case Ea:
      return Me(e);
    case Ia:
    case Sa:
      return new t(+e);
    case La:
      return Pa(e);
    case Oa:
    case xa:
    case Ga:
    case Na:
    case Fa:
    case Ra:
    case $a:
    case Ua:
    case ja:
      return Ma(e);
    case Aa:
      return new t();
    case _a:
    case va:
      return new t(e);
    case wa:
      return ya(e);
    case Ta:
      return new t();
    case Ca:
      return ba(e);
  }
}
var Da = "[object Map]";
function Ha(e) {
  return K(e) && Z(e) == Da;
}
var Ve = re && re.isMap, za = Ve ? cr(Ve) : Ha, Ba = "[object Set]";
function Va(e) {
  return K(e) && Z(e) == Ba;
}
var Ze = re && re.isSet, Za = Ze ? cr(Ze) : Va, wr = "[object Arguments]", Ka = "[object Array]", Ya = "[object Boolean]", Xa = "[object Date]", Qa = "[object Error]", Tr = "[object Function]", Ja = "[object GeneratorFunction]", Wa = "[object Map]", ka = "[object Number]", vr = "[object Object]", ei = "[object RegExp]", ri = "[object Set]", ni = "[object String]", ti = "[object Symbol]", ai = "[object WeakMap]", ii = "[object ArrayBuffer]", oi = "[object DataView]", si = "[object Float32Array]", li = "[object Float64Array]", fi = "[object Int8Array]", di = "[object Int16Array]", ci = "[object Int32Array]", mi = "[object Uint8Array]", ui = "[object Uint8ClampedArray]", pi = "[object Uint16Array]", hi = "[object Uint32Array]", M = {};
M[wr] = M[Ka] = M[ii] = M[oi] = M[Ya] = M[Xa] = M[si] = M[li] = M[fi] = M[di] = M[ci] = M[Wa] = M[ka] = M[vr] = M[ei] = M[ri] = M[ni] = M[ti] = M[mi] = M[ui] = M[pi] = M[hi] = !0;
M[Qa] = M[Tr] = M[ai] = !1;
function k(e, r, n, t, a, i) {
  var o;
  if (n && (o = a ? n(e, t, a, i) : n(e)), o !== void 0)
    return o;
  if (!fr(e))
    return e;
  var s = R(e);
  if (s)
    o = ha(e);
  else {
    var d = Z(e), f = d == Tr || d == Ja;
    if (ee(e))
      return sa(e);
    if (d == vr || d == wr || f && !a)
      o = {};
    else {
      if (!M[d])
        return a ? e : {};
      o = qa(e, d);
    }
  }
  i || (i = new O());
  var P = i.get(e);
  if (P)
    return P;
  i.set(e, o), Za(e) ? e.forEach(function(p) {
    o.add(k(p, r, n, p, e, i));
  }) : za(e) && e.forEach(function(p, y) {
    o.set(y, k(p, r, n, y, e, i));
  });
  var g = _r, u = s ? void 0 : g(e);
  return Zn(u || e, function(p, y) {
    u && (y = p, p = e[y]), hr(o, y, k(p, r, n, y, e, i));
  }), o;
}
var Pi = "__lodash_hash_undefined__";
function gi(e) {
  return this.__data__.set(e, Pi), this;
}
function yi(e) {
  return this.__data__.has(e);
}
function ae(e) {
  var r = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new N(); ++r < n; )
    this.add(e[r]);
}
ae.prototype.add = ae.prototype.push = gi;
ae.prototype.has = yi;
function bi(e, r) {
  for (var n = -1, t = e == null ? 0 : e.length; ++n < t; )
    if (r(e[n], n, e))
      return !0;
  return !1;
}
function Mi(e, r) {
  return e.has(r);
}
var Ii = 1, Si = 2;
function Cr(e, r, n, t, a, i) {
  var o = n & Ii, s = e.length, d = r.length;
  if (s != d && !(o && d > s))
    return !1;
  var f = i.get(e), P = i.get(r);
  if (f && P)
    return f == r && P == e;
  var g = -1, u = !0, p = n & Si ? new ae() : void 0;
  for (i.set(e, r), i.set(r, e); ++g < s; ) {
    var y = e[g], _ = r[g];
    if (t)
      var I = o ? t(_, y, g, r, e, i) : t(y, _, g, e, r, i);
    if (I !== void 0) {
      if (I)
        continue;
      u = !1;
      break;
    }
    if (p) {
      if (!bi(r, function(C, w) {
        if (!Mi(p, w) && (y === C || a(y, C, n, t, i)))
          return p.push(w);
      })) {
        u = !1;
        break;
      }
    } else if (!(y === _ || a(y, _, n, t, i))) {
      u = !1;
      break;
    }
  }
  return i.delete(e), i.delete(r), u;
}
function Ai(e) {
  var r = -1, n = Array(e.size);
  return e.forEach(function(t, a) {
    n[++r] = [a, t];
  }), n;
}
function _i(e) {
  var r = -1, n = Array(e.size);
  return e.forEach(function(t) {
    n[++r] = t;
  }), n;
}
var wi = 1, Ti = 2, vi = "[object Boolean]", Ci = "[object Date]", Ei = "[object Error]", Li = "[object Map]", Oi = "[object Number]", xi = "[object RegExp]", Gi = "[object Set]", Ni = "[object String]", Fi = "[object Symbol]", Ri = "[object ArrayBuffer]", $i = "[object DataView]", Ke = z ? z.prototype : void 0, de = Ke ? Ke.valueOf : void 0;
function Ui(e, r, n, t, a, i, o) {
  switch (n) {
    case $i:
      if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
        return !1;
      e = e.buffer, r = r.buffer;
    case Ri:
      return !(e.byteLength != r.byteLength || !i(new te(e), new te(r)));
    case vi:
    case Ci:
    case Oi:
      return Pe(+e, +r);
    case Ei:
      return e.name == r.name && e.message == r.message;
    case xi:
    case Ni:
      return e == r + "";
    case Li:
      var s = Ai;
    case Gi:
      var d = t & wi;
      if (s || (s = _i), e.size != r.size && !d)
        return !1;
      var f = o.get(e);
      if (f)
        return f == r;
      t |= Ti, o.set(e, r);
      var P = Cr(s(e), s(r), t, a, i, o);
      return o.delete(e), P;
    case Fi:
      if (de)
        return de.call(e) == de.call(r);
  }
  return !1;
}
var ji = 1, qi = Object.prototype, Di = qi.hasOwnProperty;
function Hi(e, r, n, t, a, i) {
  var o = n & ji, s = He(e), d = s.length, f = He(r), P = f.length;
  if (d != P && !o)
    return !1;
  for (var g = d; g--; ) {
    var u = s[g];
    if (!(o ? u in r : Di.call(r, u)))
      return !1;
  }
  var p = i.get(e), y = i.get(r);
  if (p && y)
    return p == r && y == e;
  var _ = !0;
  i.set(e, r), i.set(r, e);
  for (var I = o; ++g < d; ) {
    u = s[g];
    var C = e[u], w = r[u];
    if (t)
      var $ = o ? t(w, C, u, r, e, i) : t(C, w, u, e, r, i);
    if (!($ === void 0 ? C === w || a(C, w, n, t, i) : $)) {
      _ = !1;
      break;
    }
    I || (I = u == "constructor");
  }
  if (_ && !I) {
    var E = e.constructor, m = r.constructor;
    E != m && "constructor" in e && "constructor" in r && !(typeof E == "function" && E instanceof E && typeof m == "function" && m instanceof m) && (_ = !1);
  }
  return i.delete(e), i.delete(r), _;
}
var zi = 1, Ye = "[object Arguments]", Xe = "[object Array]", J = "[object Object]", Bi = Object.prototype, Qe = Bi.hasOwnProperty;
function Vi(e, r, n, t, a, i) {
  var o = R(e), s = R(r), d = o ? Xe : Z(e), f = s ? Xe : Z(r);
  d = d == Ye ? J : d, f = f == Ye ? J : f;
  var P = d == J, g = f == J, u = d == f;
  if (u && ee(e)) {
    if (!ee(r))
      return !1;
    o = !0, P = !1;
  }
  if (u && !P)
    return i || (i = new O()), o || sr(e) ? Cr(e, r, n, t, a, i) : Ui(e, r, d, n, t, a, i);
  if (!(n & zi)) {
    var p = P && Qe.call(e, "__wrapped__"), y = g && Qe.call(r, "__wrapped__");
    if (p || y) {
      var _ = p ? e.value() : e, I = y ? r.value() : r;
      return i || (i = new O()), a(_, I, n, t, i);
    }
  }
  return u ? (i || (i = new O()), Hi(e, r, n, t, a, i)) : !1;
}
function Er(e, r, n, t, a) {
  return e === r ? !0 : e == null || r == null || !K(e) && !K(r) ? e !== e && r !== r : Vi(e, r, n, t, Er, a);
}
function Zi(e) {
  var r = e == null ? 0 : e.length;
  return r ? e[r - 1] : void 0;
}
function Ki(e, r) {
  return r.length < 2 ? e : Ht(e, kt(r, 0, -1));
}
function Yi(e, r) {
  return Er(e, r);
}
function Xi(e, r) {
  return r = ye(r, e), e = Ki(e, r), e == null || delete e[gr(Zi(r))];
}
function Qi(e) {
  return Wt(e) ? void 0 : e;
}
var Ji = 1, Wi = 2, ki = 4, Je = Zt(function(e, r) {
  var n = {};
  if (e == null)
    return n;
  var t = !1;
  r = On(r, function(i) {
    return i = ye(i, e), t || (t = i.length > 1), i;
  }), Wn(e, _r(e), n), t && (n = k(n, Ji | Wi | ki, Qi));
  for (var a = r.length; a--; )
    Xi(n, r[a]);
  return n;
});
const eo = "api/accounts/accountToken", ro = async () => {
  var n;
  const e = await ie.post(eo, {
    tokenType: "change-password"
  });
  if (!e.ok)
    throw new Error(await e.json());
  const r = await e.json();
  return ((n = r == null ? void 0 : r.data) == null ? void 0 : n.accountToken) ?? "";
}, no = async () => {
  const r = await ie.get("api/accounts/facilities/states");
  if (!r.ok)
    throw new Error(await r.json());
  return r.json();
}, to = async (e) => {
  const n = `api/accounts/facilities?${new URLSearchParams(Object.entries(e)).toString()}`, t = await ie.get(n);
  if (!t.ok)
    throw new Error("Problem fetching data");
  return t.json();
}, ao = (e) => rr({
  queryKey: pe.accountFacilities(e.state),
  queryFn: () => to(e),
  enabled: !!e.state,
  staleTime: nr,
  select: (r) => r.data
}), io = ({
  options: e
}) => rr({
  queryKey: pe.facilitiesStates(!0),
  queryFn: no,
  staleTime: nr,
  select: (r) => r.data.filter(({ abbreviation: n }) => n !== "ALL").map(({ abbreviation: n, name: t }) => ({
    value: n,
    label: n
  }))
}), oo = {
  resetPassword: "api/support-console/sc-reset-password"
}, so = async (e) => {
  Cn();
  const r = await ie.post(oo.resetPassword, e);
  if (!r.ok)
    throw new Error("Problem with resetting password");
  return r.json();
}, lo = (e) => hn({
  mutationFn: so,
  ...e
}), fo = ({
  myHealthOneId: e,
  accountMail: r,
  showModal: n,
  setShowModal: t,
  showSnackbar: a
}) => {
  const { t: i } = x(), o = {
    onSuccess: () => {
      a("Profile password updated successfully", "success");
    },
    onError: (f) => {
      var P, g, u;
      a(
        (P = f == null ? void 0 : f.status) != null && P.messages ? (u = (g = f == null ? void 0 : f.status) == null ? void 0 : g.messages) == null ? void 0 : u.join("") : "Something went wrong while updating passsword",
        "error"
      );
    }
  }, { mutate: s } = lo(o), d = () => {
    s({ myHealthOneId: e }), t(!1);
  };
  return /* @__PURE__ */ b(
    fe,
    {
      active: n,
      label: i("MHO.SupportConsole.UserManagement.PasswordResetModal.Title"),
      onNeuDismiss: () => t(!1),
      size: "large",
      children: [
        /* @__PURE__ */ b(fe.Content, { children: [
          /* @__PURE__ */ l("div", { className: "fw-bold neu-text-blue-60 mb-5", children: r }),
          /* @__PURE__ */ b("p", { children: [
            i("MHO.SupportConsole.UserManagement.PasswordResetModal.Text"),
            " "
          ] })
        ] }),
        /* @__PURE__ */ l(fe.Footer, { children: /* @__PURE__ */ l(ue, { onClick: d, children: i("MHO.SupportConsole.UserManagement.PasswordResetModal.OkayButton") }) })
      ]
    }
  );
}, co = "_imageContainer_1xsj3_1", mo = "_editButton_1xsj3_10", uo = "_fileInput_1xsj3_17", ce = {
  imageContainer: co,
  editButton: mo,
  fileInput: uo
}, po = (e) => new Promise((r) => {
  let n = "", t = "";
  const a = new FileReader();
  a.readAsDataURL(e), a.onload = () => {
    n = a.result ?? null, t = n.replace("data:", "").replace(/^.+,/, ""), r(t);
  };
}), ho = ({
  image: e,
  setError: r,
  onUpdate: n,
  wrongTypeErrorMessage: t = "",
  fileSizeErrorMessage: a = "",
  fileSizeLimitKB: i = 700,
  fileTypes: o = ["image/png", "image/jpeg", "image/gif"]
}) => {
  const [s, d] = H(void 0);
  me(() => {
    e && d(`data:image/png;base64,${e}`);
  }, [e]);
  const f = (P) => {
    var u, p;
    r("");
    const g = P.target.files && Array.from((u = P.target) == null ? void 0 : u.files)[0];
    if (g) {
      if (!o.includes(g.type)) {
        r(t);
        return;
      }
      if (g.size > i * 1024) {
        r(a);
        return;
      }
      (p = po(g)) == null || p.then((y) => {
        n(y), d(`data:image/png;base64,${y}`);
      });
    }
  };
  return /* @__PURE__ */ l(an, { tip: "JPG, GIF or PNG. Max size of 700K", children: /* @__PURE__ */ b("div", { className: ce.imageContainer, children: [
    /* @__PURE__ */ l("div", { className: "position-absolute", children: /* @__PURE__ */ l(
      on,
      {
        color: "gray",
        image: s,
        icon: "person",
        label: "User Avatar",
        size: "xl"
      }
    ) }),
    /* @__PURE__ */ l(
      "input",
      {
        id: "fileInput",
        type: "file",
        accept: "image/png, image/jpeg, image/gif",
        className: ce.fileInput,
        onChange: f,
        style: { display: "none" }
      }
    ),
    /* @__PURE__ */ l(
      ue,
      {
        iconOnly: !0,
        icon: "edit",
        kind: "tertiary-plain",
        type: "button",
        className: ce.editButton,
        onClick: () => {
          var P;
          r(""), (P = document.getElementById("fileInput")) == null || P.click();
        },
        children: `Edit user photo. Accepts JPG, PNG or GIF, Max size of  ${i}kb`
      }
    )
  ] }) });
}, Po = (e, r = "en-US", n = {}) => new Date(e).toLocaleDateString(r, n), go = (e, r) => {
  const n = /* @__PURE__ */ new Date(), t = new Date(e), a = new Date(t.getFullYear(), t.getMonth(), t.getDate()), i = new Date(n.getFullYear() - r, n.getMonth(), n.getDate());
  return a <= i;
}, yo = ({
  onUpdate: e,
  isSupportConsole: r = !1,
  account: n
}) => {
  var o, s, d;
  const { t } = x(), [a, i] = H("");
  return /* @__PURE__ */ b(D, { children: [
    /* @__PURE__ */ b("div", { className: "w-100 d-flex flex-column flex-sm-row align-items-center justify-content-start gap-0 gap-sm-5 my-5 my-sm-0", children: [
      !r && /* @__PURE__ */ l(
        ho,
        {
          image: (n == null ? void 0 : n.photo) ?? "",
          fileSizeErrorMessage: t("Mho.PageContent.Profile.GeneralInformation.SizeErrorMessage"),
          wrongTypeErrorMessage: t(
            "Mho.PageContent.Profile.GeneralInformation.ImageRestrictionsLabel"
          ),
          onUpdate: e,
          setError: i
        }
      ),
      /* @__PURE__ */ b(
        "div",
        {
          className: er("w-100 d-flex flex-column flex-lg-row justify-content-between", {
            "my-5": r
          }),
          children: [
            /* @__PURE__ */ b("div", { className: "w-100 text-center text-sm-start", children: [
              /* @__PURE__ */ l("p", { className: "fw-heavy neu-display-6 mb-0 text-justify", children: `${n == null ? void 0 : n.user.firstName} ${n == null ? void 0 : n.user.lastName}` }),
              /* @__PURE__ */ l("p", { className: "m-0", children: n == null ? void 0 : n.user.username })
            ] }),
            /* @__PURE__ */ b("div", { className: "w-100 text-center text-sm-start", children: [
              /* @__PURE__ */ l("p", { className: "m-0", children: `${t("Mho.Profile.ProfileGeneralInformation.TopOfSpaceInfo.MyHealthOneIdLabel")}: ${(o = n == null ? void 0 : n.user) == null ? void 0 : o.myHealthOneId}` }),
              ((s = n == null ? void 0 : n.user) == null ? void 0 : s.createTimestamp) && /* @__PURE__ */ l("p", { className: "m-0", children: `${t("Mho.Profile.ProfileGeneralInformation.TopOfSpaceInfo.AccountCreatedLabel")}: ${Po((d = n == null ? void 0 : n.user) == null ? void 0 : d.createTimestamp)}` })
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ l(
      An,
      {
        showAlert: !!a,
        clearErrorState: i,
        kind: "error",
        children: a
      }
    )
  ] });
}, bo = ({
  sectionTitle: e,
  isAddressSame: r,
  stateOptions: n,
  isSupportConsole: t = !1
}) => {
  const { t: a } = x();
  return r ? null : /* @__PURE__ */ b(D, { children: [
    e && /* @__PURE__ */ l(S.SectionTitle, { title: e }),
    /* @__PURE__ */ l(S.Row, { children: /* @__PURE__ */ l(
      v,
      {
        name: "mailingAddressLine1",
        placeholder: a("Mho.Profile.ProfileGeneralInformation.MailingAddress.AddressPlaceholder"),
        label: a("Mho.Profile.ProfileGeneralInformation.MailingAddress.AddressLabel"),
        maxLength: 50,
        required: !(t || r)
      }
    ) }),
    /* @__PURE__ */ l(S.Row, { children: /* @__PURE__ */ l(
      v,
      {
        name: "mailingAddressLine2",
        placeholder: a(
          "Mho.Profile.ProfileGeneralInformation.MailingAddress.AddressSecPlaceholder"
        ),
        label: a("Mho.Profile.ProfileGeneralInformation.MailingAddress.AddressSecLabel"),
        maxLength: 50
      }
    ) }),
    /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        v,
        {
          name: "mailingAddressCity",
          placeholder: a("Mho.Profile.ProfileGeneralInformation.MailingAddress.CityPlaceholder"),
          label: a("Mho.Profile.ProfileGeneralInformation.MailingAddress.CityLabel"),
          maxLength: tr,
          required: !(t || r)
        }
      ),
      /* @__PURE__ */ b(S.Row, { children: [
        /* @__PURE__ */ l(
          F,
          {
            name: "mailingAddressState",
            label: a("Mho.Profile.ProfileGeneralInformation.MailingAddress.StateLabel"),
            items: n,
            required: !(t || r)
          }
        ),
        /* @__PURE__ */ l(
          he,
          {
            name: "mailingAddressZip",
            format: "zip",
            label: a("Mho.Profile.ProfileGeneralInformation.MailingAddress.ZipCodeLabel"),
            placeholder: a(
              "Mho.Profile.ProfileGeneralInformation.MailingAddress.ZipCodePlaceholder"
            ),
            required: !(t || r)
          }
        )
      ] })
    ] })
  ] });
}, Mo = ({
  sectionTitle: e,
  selectPhoneTypeOptions: r,
  selectPreferredContactOptions: n,
  isConnectedRelationship: t
}) => {
  const { t: a } = x();
  return /* @__PURE__ */ b(D, { children: [
    e && /* @__PURE__ */ l(S.SectionTitle, { title: e }),
    /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        he,
        {
          name: "primaryPhone",
          placeholder: a(
            "Mho.Profile.ProfileGeneralInformation.MainContactSection.PrimaryPhonePlaceholder"
          ),
          label: a("Mho.Profile.ProfileGeneralInformation.MainContactSection.PrimaryPhoneLabel"),
          format: "phone",
          required: !0
        }
      ),
      /* @__PURE__ */ l(
        F,
        {
          name: "phoneType",
          label: a("Mho.Profile.ProfileGeneralInformation.MainContactSection.PhoneTypeLabel"),
          items: r,
          required: !0
        }
      )
    ] }),
    /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        v,
        {
          name: "userEmail",
          label: a("Mho.Profile.ProfileGeneralInformation.MainContactSection.EmailLabel"),
          placeholder: a(
            "Mho.Profile.ProfileGeneralInformation.MainContactSection.EmailPlaceholder"
          ),
          required: !t
        }
      ),
      /* @__PURE__ */ l(
        F,
        {
          name: "preferredContact",
          label: a(
            "Mho.Profile.ProfileGeneralInformation.MainContactSection.ContactPreferenceLabel"
          ),
          items: n,
          required: !t
        }
      )
    ] })
  ] });
}, Io = ({
  label: e,
  changePasswordHandler: r,
  setShowResetPasswordModal: n,
  isSupportConsole: t
}) => {
  const { t: a } = x(), { isDesktop: i } = Fn(), o = a(t ? "Mho.Profile.ProfileGeneralInformation.PersonalSection.ResetPassword" : i ? "Mho.Profile.ProfileGeneralInformation.PersonalSection.ChangePassword" : "Mho.Profile.ProfileGeneralInformation.PersonalSection.ChangePasswordMobile");
  return /* @__PURE__ */ b("div", { className: "w-100 position-relative", children: [
    /* @__PURE__ */ l(sn, { label: e, disabled: !0, value: "*******", required: !0 }),
    /* @__PURE__ */ l(
      ue,
      {
        className: "position-absolute ",
        size: "small",
        style: { top: "31px", right: "15px" },
        role: "link",
        onNeuClick: t ? () => n(!0) : r,
        children: /* @__PURE__ */ l("div", { className: "neu-text-support neu-text-plain-0", children: o })
      }
    )
  ] });
}, So = ({
  sectionTile: e,
  selectGenderOptions: r,
  changePasswordHandler: n,
  setShowResetPasswordModal: t,
  isDobDisabled: a,
  isDobRequired: i,
  isSupportConsole: o,
  isConnectedRelationship: s,
  relationTypes: d
}) => {
  const { t: f } = x();
  return /* @__PURE__ */ b(D, { children: [
    e && /* @__PURE__ */ l(S.SectionTitle, { title: e }),
    s ? /* @__PURE__ */ l(S.Row, { children: /* @__PURE__ */ l(
      F,
      {
        name: "relationship",
        label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.Relationship"),
        items: d || [],
        required: !0
      }
    ) }) : /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        v,
        {
          name: "userName",
          placeholder: f(
            "Mho.Profile.ProfileGeneralInformation.PersonalSection.UsernamePlaceholder"
          ),
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.UsernameLabel"),
          maxLength: 100,
          required: !0
        }
      ),
      /* @__PURE__ */ l(
        Io,
        {
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.PasswordLabel"),
          changePasswordHandler: n,
          setShowResetPasswordModal: t,
          isSupportConsole: o
        }
      )
    ] }),
    /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        v,
        {
          name: "firstName",
          placeholder: f(
            "Mho.Profile.ProfileGeneralInformation.PersonalSection.FirstNamePlaceholder"
          ),
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.FirstNameLabel"),
          maxLength: 100,
          required: !0
        }
      ),
      /* @__PURE__ */ l(
        v,
        {
          name: "middleName",
          placeholder: f(
            "Mho.Profile.ProfileGeneralInformation.PersonalSection.MiddleNamePlaceholder"
          ),
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.MiddleNameLabel"),
          maxLength: 100
        }
      )
    ] }),
    /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        v,
        {
          name: "lastName",
          placeholder: f(
            "Mho.Profile.ProfileGeneralInformation.PersonalSection.LastNamePlaceholder"
          ),
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.LastNameLabel"),
          maxLength: 100,
          required: !0
        }
      ),
      /* @__PURE__ */ l(
        v,
        {
          name: "preferredName",
          placeholder: f(
            "Mho.Profile.ProfileGeneralInformation.PersonalSection.PreferredNamePlaceholder"
          ),
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.PreferredNameLabel"),
          maxLength: 100
        }
      )
    ] }),
    /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        v,
        {
          name: "suffix",
          placeholder: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.SuffixPlaceholder"),
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.SuffixLabel"),
          maxLength: 10
        }
      ),
      /* @__PURE__ */ l(
        F,
        {
          name: "gender",
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.SexAtBirthLabel"),
          items: r,
          nullItemLabel: f(
            "Mho.Profile.ProfileGeneralInformation.PersonalSection.SexAtBirthPlaceholder.Select"
          ),
          required: !o
        }
      ),
      /* @__PURE__ */ l(
        Nn,
        {
          name: "dob",
          label: f("Mho.Profile.ProfileGeneralInformation.PersonalSection.DateOfBirthLabel"),
          disabled: a,
          required: i,
          min: ar,
          max: (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
          disabledDays: []
        }
      )
    ] })
  ] });
}, Ao = "_formItemPreferredFacilityState_1eisr_1", _o = "_formItemPreferredFacility_1eisr_1", We = {
  formItemPreferredFacilityState: Ao,
  formItemPreferredFacility: _o
}, wo = ({
  sectionTitle: e,
  disclaimer: r,
  selectFacilityStateOptions: n,
  selectFacilityOptions: t,
  isConnectedRelationship: a
}) => {
  const { t: i } = x(), { setValue: o } = en(), s = () => {
    o("preferredFacility", "", { shouldValidate: !0 });
  };
  return /* @__PURE__ */ b(D, { children: [
    e && /* @__PURE__ */ l(S.SectionTitle, { title: e }),
    r && /* @__PURE__ */ l("p", { children: r }),
    /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        F,
        {
          name: "preferredFacilityState",
          formOnChange: s,
          className: We.formItemPreferredFacilityState,
          label: i("Mho.Profile.ProfileGeneralInformation.PreferredFacility.StateLabel"),
          items: n,
          addNullItem: !1,
          required: !a
        }
      ),
      /* @__PURE__ */ l(
        F,
        {
          name: "preferredFacility",
          label: i(
            "Mho.Profile.ProfileGeneralInformation.PreferredFacility.PreferredFacilityLabel"
          ),
          className: We.formItemPreferredFacility,
          items: t,
          addNullItem: !1,
          required: !a
        }
      )
    ] })
  ] });
}, To = ({
  sectionTitle: e,
  stateOptions: r,
  isAddressSame: n,
  setIsAddressSame: t,
  isSupportConsole: a,
  isConnectedRelationship: i,
  isAddressRequired: o
}) => {
  const { t: s } = x();
  return /* @__PURE__ */ b(D, { children: [
    e && /* @__PURE__ */ l(S.SectionTitle, { title: e }),
    /* @__PURE__ */ l(S.Row, { children: /* @__PURE__ */ l(
      v,
      {
        name: "primaryAddressLine1",
        placeholder: s("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.AddressPlaceholder"),
        label: s("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.AddressLabel"),
        maxLength: 50,
        required: !(a || i) || o
      }
    ) }),
    /* @__PURE__ */ l(S.Row, { children: /* @__PURE__ */ l(
      v,
      {
        name: "primaryAddressLine2",
        placeholder: s(
          "Mho.Profile.ProfileGeneralInformation.PrimaryAddress.AddressSecPlaceholder"
        ),
        label: s("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.AddressSecLabel"),
        maxLength: 50
      }
    ) }),
    /* @__PURE__ */ b(S.Row, { children: [
      /* @__PURE__ */ l(
        v,
        {
          name: "primaryAddressCity",
          placeholder: s("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.CityPlaceholder"),
          label: s("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.CityLabel"),
          maxLength: tr,
          required: !(a || i) || o
        }
      ),
      /* @__PURE__ */ b(S.Row, { children: [
        /* @__PURE__ */ l(
          F,
          {
            name: "primaryAddressState",
            label: s("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.StateLabel"),
            items: r,
            required: !(a || i) || o
          }
        ),
        /* @__PURE__ */ l(
          he,
          {
            name: "primaryAddressZip",
            format: "zip",
            label: s("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ZipCodeLabel"),
            placeholder: s(
              "Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ZipCodePlaceholder"
            ),
            required: !(a || i) || o
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ l(S.Row, { children: /* @__PURE__ */ l(
      ln,
      {
        label: s("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.MailingCheckBoxLabel"),
        checked: n,
        onChange: () => t((d) => !d)
      }
    ) })
  ] });
}, vo = (e = []) => {
  const r = Je(
    e == null ? void 0 : e.find(({ addressType: t }) => t === "PRIMARY"),
    "addressType"
  ), n = Je(
    e == null ? void 0 : e.find(({ addressType: t }) => t === "MAILING"),
    "addressType"
  );
  return {
    primaryAddress: r,
    mailingAddress: n
  };
}, Co = (e, r) => Yi(e, r), Eo = ({
  currUserData: e,
  formData: r,
  isAddressSame: n,
  preferredFacility: t
}) => {
  const a = {
    username: r.userName,
    firstName: r.firstName,
    middleName: r.middleName,
    lastName: r.lastName,
    preferredName: r.preferredName,
    suffix: r.suffix,
    gender: r.gender || null,
    dob: xn(r.dob)
  };
  function i(u) {
    const p = [];
    return u.userEmail && p.push({
      contactInfo: u.userEmail,
      contactType: L.email,
      isPreferred: u.preferredContact === L.email
    }), p.push({
      contactInfo: u.primaryPhone,
      contactType: u.phoneType,
      isPreferred: u.preferredContact === L.phone
    }), p;
  }
  const o = i(r), s = [
    {
      addressType: "PRIMARY",
      country: "US",
      addressLine1: r.primaryAddressLine1,
      addressLine2: r.primaryAddressLine2,
      city: r.primaryAddressCity,
      state: r.primaryAddressState,
      zip: r.primaryAddressZip
    },
    {
      addressType: "MAILING",
      country: "US",
      addressLine1: !n && r.mailingAddressLine1 ? r.mailingAddressLine1 : r.primaryAddressLine1,
      addressLine2: !n && r.mailingAddressLine2 ? r.mailingAddressLine2 : r.primaryAddressLine2,
      city: !n && r.mailingAddressCity ? r.mailingAddressCity : r.primaryAddressCity,
      state: !n && r.mailingAddressState ? r.mailingAddressState : r.primaryAddressState,
      zip: !n && r.mailingAddressZip ? r.mailingAddressZip : r.primaryAddressZip
    }
  ], { groups: d, myHealthOneId: f, accountDisabled: P, createTimestamp: g } = e.user;
  return {
    user: {
      groups: d,
      myHealthOneId: f,
      accountDisabled: P,
      createTimestamp: g,
      ...a,
      preferredFacility: t
    },
    contacts: o,
    addresses: s
  };
}, ke = ({
  account: e,
  primaryAddress: r,
  mailingAddress: n,
  relationType: t
} = {}) => {
  var a, i, o, s, d, f, P, g, u, p, y, _, I, C, w, $, E;
  return {
    userName: ((a = e == null ? void 0 : e.user) == null ? void 0 : a.username) || "",
    firstName: ((i = e == null ? void 0 : e.user) == null ? void 0 : i.firstName) || "",
    middleName: ((o = e == null ? void 0 : e.user) == null ? void 0 : o.middleName) || "",
    lastName: ((s = e == null ? void 0 : e.user) == null ? void 0 : s.lastName) || "",
    preferredName: ((d = e == null ? void 0 : e.user) == null ? void 0 : d.preferredName) || "",
    suffix: ((f = e == null ? void 0 : e.user) == null ? void 0 : f.suffix) || "",
    gender: ((P = e == null ? void 0 : e.user) == null ? void 0 : P.gender) || "",
    dob: ((g = e == null ? void 0 : e.user) == null ? void 0 : g.dob) || "",
    primaryPhone: ((p = (u = e == null ? void 0 : e.contacts) == null ? void 0 : u.find(({ contactType: m }) => m !== L.email)) == null ? void 0 : p.contactInfo) || "",
    phoneType: ((_ = (y = e == null ? void 0 : e.contacts) == null ? void 0 : y.find(({ contactType: m }) => m !== L.email)) == null ? void 0 : _.contactType) || "",
    userEmail: ((C = (I = e == null ? void 0 : e.contacts) == null ? void 0 : I.find(({ contactType: m }) => m === L.email)) == null ? void 0 : C.contactInfo) || "",
    preferredContact: (w = e == null ? void 0 : e.contacts) != null && w.some(
      ({ isPreferred: m, contactType: le }) => m && le === L.email
    ) ? L.email : L.phone,
    primaryAddressLine1: (r == null ? void 0 : r.addressLine1) || "",
    primaryAddressLine2: (r == null ? void 0 : r.addressLine2) || "",
    primaryAddressCity: (r == null ? void 0 : r.city) || "",
    primaryAddressState: (r == null ? void 0 : r.state) || "",
    primaryAddressZip: (r == null ? void 0 : r.zip) || "",
    mailingAddressLine1: (n == null ? void 0 : n.addressLine1) || "",
    mailingAddressLine2: (n == null ? void 0 : n.addressLine2) || "",
    mailingAddressCity: (n == null ? void 0 : n.city) || "",
    mailingAddressState: (n == null ? void 0 : n.state) || "",
    mailingAddressZip: (n == null ? void 0 : n.zip) || "",
    preferredFacilityState: (($ = e == null ? void 0 : e.user.preferredFacility) == null ? void 0 : $.state.abbreviation) || "",
    preferredFacility: ((E = e == null ? void 0 : e.user.preferredFacility) == null ? void 0 : E.cookieValue) || "",
    relationship: t
  };
}, Lo = {
  primaryAddressLine1: "primaryAddressLine1",
  primaryAddressLine2: "primaryAddressLine2",
  primaryAddressCity: "primaryAddressCity",
  primaryAddressState: "primaryAddressState",
  primaryAddressZip: "primaryAddressZip"
}, Oo = (e) => c().min(1, { message: e }).regex(A.username, {
  message: e
}), xo = (e) => c().regex(A.email, {
  message: e
}), Go = (e) => c().regex(A.phone, {
  message: e
}), No = (e) => c().regex(A.phoneUnformatted, {
  message: e
}), Fo = (e, r, n, t, a, i) => {
  const o = !t && a && !i;
  return mn({
    userName: Oo(
      e("Mho.Profile.ProfileGeneralInformation.PersonalSection.UsernameErrorMessage")
    ).or(
      xo(
        e("Mho.Profile.ProfileGeneralInformation.PersonalSection.UsernameErrorMessage")
      )
    ),
    firstName: c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PersonalSection.FirstNameErrorMessage")
    }).regex(A.name, {
      message: e("Mho.Profile.ProfileGeneralInformation.PersonalSection.FirstNameErrorMessage")
    }),
    middleName: c().regex(A.name, {
      message: e("Mho.Profile.ProfileGeneralInformation.PersonalSection.MiddleNameErrorMessage")
    }),
    lastName: c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PersonalSection.LastNameErrorMessage")
    }).regex(A.name, {
      message: e("Mho.Profile.ProfileGeneralInformation.PersonalSection.LastNameErrorMessage")
    }),
    preferredName: c().regex(A.name, {
      message: e("Mho.Profile.ProfileGeneralInformation.PersonalSection.PreferredNameErrorMessage")
    }),
    suffix: c().regex(A.suffix, {
      message: e("Mho.Profile.ProfileGeneralInformation.PersonalSection.SuffixErrorMessage")
    }),
    gender: i ? c().optional() : c().min(1, {
      message: e(
        "Mho.Profile.ProfileGeneralInformation.PersonalSection.SexAtBirthErrorMessage"
      )
    }),
    dob: n ? c() : c().min(1, { message: e("Mho.PageContent.RecordsLinking.Form.Validations.ValidDate") }).refine((s) => new Date(s) >= new Date(ar), {
      message: e("Mho.PageContent.RecordsLinking.Form.Validations.ValidDateEarliest")
    }).refine((s) => new Date(s) < /* @__PURE__ */ new Date(), {
      message: e("Mho.PageContent.RecordsLinking.Form.Validations.ValidDateFuture")
    }).refine(
      (s) => {
        const d = new Date(s);
        return go(d, bn);
      },
      {
        message: e("Mho.PageContent.RecordsLinking.Form.Validations.ValidDateMinimumProfile")
      }
    ),
    primaryPhone: Go(
      e("Mho.Profile.ProfileGeneralInformation.MainContactSection.ErrorPhoneValidation")
    ).or(
      No(
        e("Mho.Profile.ProfileGeneralInformation.MainContactSection.ErrorPhoneValidation")
      )
    ),
    phoneType: c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.MainContactSection.ErrorValidPhoneType")
    }),
    userEmail: t ? c().or(V("")) : c().min(1, {
      message: e(
        "Mho.Profile.ProfileGeneralInformation.MainContactSection.ErrorValidEmailAddress"
      )
    }).regex(A.email, {
      message: e(
        "Mho.Profile.ProfileGeneralInformation.MainContactSection.ErrorValidEmailAddress"
      )
    }),
    preferredContact: t ? c().optional() : c().min(1, {
      message: e(
        "Mho.Profile.ProfileGeneralInformation.MainContactSection.ErrorValidContactPreference"
      )
    }),
    primaryAddressLine1: o ? c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidAddress")
    }).regex(A.address, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidAddress")
    }) : c().or(V("")),
    primaryAddressLine2: c().regex(A.address, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidAddress")
    }),
    primaryAddressCity: o ? c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidCity")
    }).regex(A.state, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidCity")
    }) : c().or(V("")),
    primaryAddressState: o ? c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidState")
    }) : c().or(V("")),
    primaryAddressZip: o ? c().regex(A.zipCode, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidZip")
    }) : c().or(V("")),
    mailingAddressLine1: r || !o ? c().optional() : c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidAddress")
    }).regex(A.address, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidAddress")
    }),
    mailingAddressLine2: r || !o ? c().optional() : c().regex(A.address, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidAddress")
    }),
    mailingAddressCity: r || !o ? c().optional() : c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidCity")
    }).regex(A.state, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidCity")
    }),
    mailingAddressState: r || !o ? c().optional() : c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidState")
    }),
    mailingAddressZip: r || !o ? c().optional() : c().regex(A.zipCode, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidZip")
    }),
    preferredFacility: t ? c().optional() : c().min(1, {
      message: e(
        "Mho.Profile.ProfileGeneralInformation.PreferredFacility.PreferredFacilityError"
      )
    }),
    preferredFacilityState: t ? c().optional() : c().min(1, {
      message: e("Mho.Profile.ProfileGeneralInformation.PrimaryAddress.ErrorValidState")
    }),
    // relationship only rendered when editing connected relationship
    relationship: t ? c().min(1, {
      message: "Please enter relationship type"
    }) : c().optional()
  });
}, Ro = (e) => e.map(({ fields: r }) => ({
  value: r.genderOption.value.toUpperCase(),
  label: r.genderOption.value
})).sort((r, n) => n == null ? void 0 : n.value.localeCompare(r == null ? void 0 : r.value)), $o = (e) => e.map(({ fields: r }) => ({
  value: r.phoneType.value.toUpperCase(),
  label: r.phoneType.value
})), Uo = (e) => e.map(({ fields: r }) => ({
  value: r.contactPreference.value.toUpperCase(),
  label: r.contactPreference.value
})), W = (e) => {
  if (e)
    return e instanceof Error ? e.message : String(e);
}, jo = ({
  fields: e,
  rendering: r
}) => {
  var Te, ve, Ce, Ee, Le, Oe, xe, Ge, Ne;
  const { t: n } = x(), { snackbarProps: t, showSnackbar: a } = un(), [i, o] = H(!0), [s, d] = H(!1), [f, P] = H(!1), [g, u] = H(), p = !!((Te = e.isSupportConsole) != null && Te.value), y = tn(), _ = p ? !y : !1, {
    isConnectedRelationship: I,
    connectedRelUsername: C,
    connectedRelId: w,
    queryParams: $,
    mainUserMhoId: E
  } = vn(), {
    data: m,
    isFetching: le,
    error: Lr
  } = Rn({
    queryParams: $,
    enabled: p ? y : !0
  }), Or = ((Ce = (ve = m == null ? void 0 : m.contacts) == null ? void 0 : ve.find(({ contactType: h }) => h === L.email)) == null ? void 0 : Ce.contactInfo) || "", { data: X = [] } = nn(I), Ie = !((Ee = m == null ? void 0 : m.user) != null && Ee.groups.includes("CONSUMERS")) && !I, xr = ((Oe = (Le = m == null ? void 0 : m.user) == null ? void 0 : Le.groups) == null ? void 0 : Oe.some((h) => ["PATIENTS", "CONSUMERS"].includes(h))) ?? !1, B = rn({
    mode: "all",
    defaultValues: ke(),
    resolver: pn(
      Fo(
        n,
        i,
        Ie,
        I,
        f,
        p
      )
    )
  }), { reset: Se, watch: Gr } = B, [Nr, Fr, Rr, $r] = Gr([
    "firstName",
    "lastName",
    "relationship",
    "preferredFacilityState"
  ]), { mutate: Ur, isPending: jr } = Tn(), { mutate: Ae, isPending: qr } = gn({
    onMutate: () => {
      u("");
    },
    onSuccess: () => {
      var h;
      I && E && m && Ur({
        payload: {
          firstName: Nr,
          lastName: Fr,
          relationType: Rr,
          id: w,
          myHealthOneId: ((h = m == null ? void 0 : m.user) == null ? void 0 : h.myHealthOneId) || ""
        },
        mhoId: E
      }), a(
        n("Mho.PageContent.Profile.GeneralInformation.ProfileSuccessfullyChanged"),
        "success"
      );
    },
    onError: (h) => {
      h instanceof Error ? u(h.message) : u(String(h));
    }
  });
  me(() => {
    const h = Object.values(Lo).some((T) => typeof B.getValues(T) < "u" && B.getValues(T) !== "");
    P(h);
  }, [B.getValues()]);
  const Dr = Pn(), Hr = (h) => {
    Ae(
      {
        user: { myHealthOneId: (m == null ? void 0 : m.user.myHealthOneId) ?? "" },
        photo: h
      },
      {
        onSuccess: () => {
          a(
            n("Mho.PageContent.Profile.GeneralInformation.ProfileSuccessfullyChanged"),
            "success"
          ), Dr.invalidateQueries({
            queryKey: pe.user("PHOTO")
          });
        }
      }
    );
  }, _e = Re(
    () => {
      var h;
      return ((h = X == null ? void 0 : X.find((T) => (T == null ? void 0 : T.id) === w)) == null ? void 0 : h.relationType) ?? "";
    },
    [w, X]
  );
  me(() => {
    var h;
    if ((h = m == null ? void 0 : m.user) != null && h.myHealthOneId) {
      const { primaryAddress: T, mailingAddress: j } = vo(m.addresses);
      o(Co(T, j)), Se(ke({ account: m, primaryAddress: T, mailingAddress: j, relationType: _e }));
    }
  }, [m, _e, Se]);
  const zr = Ro(e.sexAtBirth), Br = $o(e.phoneType), Vr = Uo(e.contactPreference), { data: we = [], error: Zr } = yn({
    options: {
      isAbbreviationAsLabel: !0
    }
  }), { data: Kr = [], error: Yr } = io({
    options: {}
  }), { data: Xr } = Gn(I), { data: U = [], error: Qr } = ao({ state: $r || "" }), Jr = Re(
    () => U == null ? void 0 : U.map((h) => ({
      value: (h == null ? void 0 : h.cookieValue) || "",
      label: h.displayName
    })),
    [U]
  ), Wr = (h) => {
    if (!m)
      return;
    const T = U == null ? void 0 : U.find(
      (Q) => Q.cookieValue === h.preferredFacility
    ), j = Eo({
      currUserData: m,
      formData: h,
      preferredFacility: T,
      isAddressSame: i
    });
    Ae({ ...j, connectedRelUsername: C });
  }, kr = async () => {
    var T, j, Q, Fe;
    const h = await ro();
    h && typeof window < "u" && ((Fe = (Q = (j = (T = e == null ? void 0 : e.changePasswordLink) == null ? void 0 : T.fields) == null ? void 0 : j.link) == null ? void 0 : Q.value) != null && Fe.href) && (window.location.href = e.changePasswordLink.fields.link.value.href + h);
  };
  return /* @__PURE__ */ l(fn, { className: p ? "p-3 mt-5" : "bg-transparent p-3", children: /* @__PURE__ */ b(
    _n,
    {
      componentName: r == null ? void 0 : r.componentName,
      level: "2",
      titleClassName: "neu-display-3 fw-bold",
      titleText: e.title.value,
      descriptionRichText: e.description,
      errorMessage: W(Lr) || W(Zr) || W(Yr) || W(Qr) || g,
      children: [
        le || _ || qr || jr ? (
          /* Loading state */
          /* @__PURE__ */ l(dn, { kind: "spinner", className: "px-6 py-4" })
        ) : /* @__PURE__ */ b(D, { children: [
          !I && /* @__PURE__ */ l(
            yo,
            {
              onUpdate: Hr,
              isSupportConsole: p,
              account: m
            }
          ),
          /* @__PURE__ */ b(
            S,
            {
              methods: B,
              onSubmit: Wr,
              id: "profile-general-form",
              padding: "px-0",
              isUnsavedChangesModalEnabled: !0,
              unsavedChangesModalTitle: n(
                "Mho.Profile.ProfileGeneralInformation.UnsavedChangesModal.ModalTitle"
              ),
              unsavedChangesModalText: n("Mho.PageContent.Profile.UnsavedChanges.Content"),
              unsavedChangesModalSaveLabel: n(
                "Mho.Profile.ProfileGeneralInformation.UnsavedChangesModal.SaveLabel"
              ),
              unsavedChangesModalDiscardLabel: n(
                "Mho.Profile.ProfileGeneralInformation.UnsavedChangesModal.DiscardLabel"
              ),
              className: er({ "mt-4": I }),
              children: [
                /* @__PURE__ */ l(
                  So,
                  {
                    sectionTile: (xe = e.personalSectionTitle) == null ? void 0 : xe.value,
                    selectGenderOptions: zr,
                    changePasswordHandler: kr,
                    setShowResetPasswordModal: d,
                    isDobDisabled: Ie,
                    isDobRequired: xr,
                    isSupportConsole: p,
                    isConnectedRelationship: I,
                    relationTypes: Xr
                  }
                ),
                /* @__PURE__ */ l(
                  Mo,
                  {
                    sectionTitle: (Ge = e.mainContactTitle) == null ? void 0 : Ge.value,
                    selectPhoneTypeOptions: Br,
                    selectPreferredContactOptions: Vr,
                    isConnectedRelationship: I
                  }
                ),
                /* @__PURE__ */ l(
                  To,
                  {
                    sectionTitle: e.primaryAddressTitle.value,
                    stateOptions: we,
                    isAddressSame: i,
                    setIsAddressSame: o,
                    isSupportConsole: p,
                    isConnectedRelationship: I,
                    isAddressRequired: f
                  }
                ),
                /* @__PURE__ */ l(
                  bo,
                  {
                    sectionTitle: e.mailingAddressTitle.value,
                    isAddressSame: i,
                    stateOptions: we,
                    isSupportConsole: p
                  }
                ),
                /* @__PURE__ */ l(
                  wo,
                  {
                    sectionTitle: e.preferredFacilityTitle.value,
                    disclaimer: e.disclaimer.value,
                    selectFacilityStateOptions: Kr,
                    selectFacilityOptions: Jr,
                    isConnectedRelationship: I
                  }
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ l(cn, { ...t }),
        p && /* @__PURE__ */ l(
          fo,
          {
            myHealthOneId: ((Ne = m == null ? void 0 : m.user) == null ? void 0 : Ne.myHealthOneId) || "",
            accountMail: Or,
            showModal: s,
            setShowModal: d,
            showSnackbar: a
          }
        )
      ]
    }
  ) });
}, us = wn()(jo);
export {
  us as MhoProfileGeneralInformation
};
